import React, { useState } from "react";
import "./leadpage.scss";
// Ensure the path to your logo is correct
import fitojaLogo from "../assets/fitoja-logo.png";

const App = () => {
  return <LeadPage />;
};

const LeadPage = () => {
  const [formData, setFormData] = useState({
    phoneNumber: "",
    fullName: "",
    age: "",
    goal: "",
    gender: "",
    height: "",
    weight: "",
    city: "",
    state: "",
    healthIssue: "",
    takingAnyMedicine: "",
    preferredWayToConnect: "",
    budget: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const apiData = {
      fullName: formData.fullName,
      phoneNumber: formData.phoneNumber,
      age: formData.age,
      goal: formData.goal,
      gender: formData.gender,
      height: formData.height,
      weight: formData.weight,
      city: formData.city,
      state: formData.state,
      healthIssue: formData.healthIssue,
      takingAnyMedicine: formData.takingAnyMedicine,
      preferredWayToConnect: formData.preferredWayToConnect,
      budget: formData.budget,
    };

    try {
      const response = await fetch(
        "https://api.fitoja.in/api/submit-lead-form",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(apiData),
        }
      );

      if (response.ok) {
        // WhatsApp Redirect
        const whatsappMessage = `Hi, I submitted my details on Fitoja:\nName: ${formData.fullName}\nAge: ${formData.age}\nGoal: ${formData.goal}`;
        const url = `https://wa.me/919891113123?text=${encodeURIComponent(
          whatsappMessage
        )}`;

        // Clear form
        setFormData({
          phoneNumber: "",
          fullName: "",
          age: "",
          goal: "",
          gender: "",
          height: "",
          weight: "",
          city: "",
          state: "",
          healthIssue: "",
          takingAnyMedicine: "",
          preferredWayToConnect: "",
          budget: "",
        });

        window.open(url, "_blank");
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lead-page">
      <div className="lead-container">
        {/* Left Side: Branding */}
        <div className="lead-left">
          <div className="brand-content">
            <img src={fitojaLogo} alt="Fitoja Logo" className="logo" />
            <h1>Get Your Personalized Diet Plan</h1>
            <p className="subtitle">India’s Smartest Way to Lose Weight.</p>
            <div className="features-list">
              <span>✓ Personalized Diet</span>
              <span>✓ 2 Pro Coaches</span>
              <span>✓ 24×7 Support</span>
              <span>✓ Weekly Reviews</span>
              <span>✓ Guranteed Weight Lose</span>
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="lead-right">
          <form onSubmit={handleSubmit}>
            <div className="form-header">
              <h2>Fill details to start your diet plan</h2>
            </div>

            <div className="form-grid">
              {/* Full Width */}
              <div className="input-group full-width">
                <input
                  type="tel"
                  name="phoneNumber"
                  placeholder="Call/WhatsApp Number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  pattern="[0-9]{10}"
                  maxLength={10}
                  required
                />
              </div>

              <div className="input-group full-width">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Half Width Group 1 */}
              <div className="input-group">
                <input
                  type="number"
                  name="age"
                  placeholder="Age"
                  value={formData.age}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              {/* Half Width Group 2 */}
              <div className="input-group">
                <input
                  type="text"
                  name="height"
                  placeholder="Height (e.g. 5 ft 4 in)"
                  value={formData.height}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="weight"
                  placeholder="Weight (kg)"
                  value={formData.weight}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Full Width Goal */}
              <div className="input-group full-width">
                <select
                  name="goal"
                  value={formData.goal}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Goal</option>
                  <option value="Weight Loss">Weight Loss</option>
                  <option value="Weight Gain">Weight Gain</option>
                  <option value="Muscle Gain">Muscle Gain</option>
                  <option value="Just Exploring">Just Exploring...</option>
                </select>
              </div>

              {/* Half Width Group 3 */}
              <div className="input-group">
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  value={formData.state}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Half Width Group 4 */}
              <div className="input-group">
                <input
                  type="text"
                  name="healthIssue"
                  placeholder="Health Issues (if any)"
                  value={formData.healthIssue}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <select
                  name="takingAnyMedicine"
                  value={formData.takingAnyMedicine}
                  onChange={handleChange}
                  required
                >
                  <option value="">Taking any Medicine?</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {/* Half Width Group 5 */}
              <div className="input-group">
                <select
                  name="preferredWayToConnect"
                  value={formData.preferredWayToConnect}
                  onChange={handleChange}
                  required
                >
                  <option value="">Connect via?</option>
                  <option value="Call">Call</option>
                  <option value="WhatsApp">WhatsApp</option>
                </select>
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="budget"
                  placeholder="Monthly Budget"
                  value={formData.budget}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div>
              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="submit-btn full-width"
              >
                {loading ? "Submitting..." : "Get Your Personalized Diet Plan →"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default App;
